import { render, staticRenderFns } from "./NotificationActivityTable.vue?vue&type=template&id=701f90d8&scoped=true"
import script from "./NotificationActivityTable.vue?vue&type=script&lang=js"
export * from "./NotificationActivityTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationActivityTable.vue?vue&type=style&index=0&id=701f90d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f90d8",
  null
  
)

export default component.exports